import { z } from 'zod';

export interface MasjidMember {
  readonly id: string;
  readonly masjidId: string;
  readonly userId: string;
  readonly role: string;
  readonly memberName: string | null;
}

const rowSchema = z.object({
  id: z.string(),
  masjid_id: z.string(),
  user_id: z.string(),
  role: z.string(),
  member: z.object({ full_name: z.string() }).nullable().optional(),
});

export function mapMasjidMember(row: unknown): MasjidMember {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    masjidId: r.masjid_id,
    userId: r.user_id,
    role: r.role,
    memberName: r.member?.full_name ?? null,
  };
}
